import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faHome, faEnvelope, faUser, faCopyright, faClock } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons';
import '../css/IconTray.css';

function IconTray({ toggleSidebar, visible }) {

  return (
    <div className={`icon-tray ${visible ? 'visible' : 'hidden'}`}>
      <div className="hamburger-menu">
        <FontAwesomeIcon
          icon={faClock}
          className="icon"
          onClick={() => {
            // アニメーション用に一旦隠す（旧仕様のまま）
            const tray = document.querySelector('.icon-tray');
            tray?.classList.remove('visible');
            tray?.classList.add('hidden');

            // Sidebar を開く
            setTimeout(() => toggleSidebar(true), 160);
          }}
        />
      </div>

      <div className="separator"></div>

      <div className="social-links">
        <a href="/"><FontAwesomeIcon icon={faHome} className="icon" /></a>

        <a href="https://blog.suikashobo.com" target="_blank">
          <img src="/images/suika3.svg" alt="Watermelon Icon" className="social-icon" />
        </a>

        <a href="https://github.com/AbeHiroto" target="_blank">
          <FontAwesomeIcon icon={faGithub} className="icon" />
        </a>

        <a href="/contact"><FontAwesomeIcon icon={faEnvelope} className="icon" /></a>
        <a href="/about"><FontAwesomeIcon icon={faUser} className="icon" /></a>
      </div>
    </div>
  );
}

export default IconTray;
